import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  goToFormazione() {
    window.open('https://futuri.my.canva.site/', '_blank')
  }

  goToTutorial() {
    window.open('https://futuri.my.canva.site/futuri-tutorial', '_blank')
  }

}
